import { Component, inject, Input } from '@angular/core';
import { UploadProgressService } from "../../../../../../../core/services/upload-progress.service";

@Component({
  selector: 'app-telegram-upload-status',
  standalone: true,
  imports: [],
  templateUrl: './telegram-upload-status.component.html',
  styleUrl: './telegram-upload-status.component.scss'
})
export class TelegramUploadStatusComponent {
  @Input() useGridLayout: boolean = true;

  public uploadProgressService: UploadProgressService = inject(UploadProgressService);
}
